import { render, staticRenderFns } from "./BrandPrompt.vue?vue&type=template&id=68ac7c4c"
import script from "./BrandPrompt.vue?vue&type=script&lang=js"
export * from "./BrandPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports